import { t } from "@/i18n-js/instance";
import { Form } from "@/react/components/shared/uikit/Form";
import { Typography } from "@circle-react-shared/uikit/Typography";

interface RemainingTimeInputProps {
  formClassName: string;
  name: string;
  translationRoot: string;
}

const REMAINING_TIME_MAX_MINUTES = 4320;
const REMAINING_TIME_MIN_MINUTES = 1;

const returnOnlyValidNumbers = (input: string): number => {
  const newValue = Number(input.replace(/\D/g, ""));
  if (newValue >= REMAINING_TIME_MAX_MINUTES) {
    return REMAINING_TIME_MAX_MINUTES;
  }

  if (newValue < REMAINING_TIME_MIN_MINUTES) {
    return REMAINING_TIME_MIN_MINUTES;
  }

  return newValue;
};

const blockScroll = (e: any) => {
  e.target.blur();
};

export const RemainingTimeInput = ({
  name,
  formClassName,
  translationRoot,
}: RemainingTimeInputProps) => (
  <Form.Item
    className={formClassName}
    name={name}
    translationRoot={translationRoot}
    hideLabel
    hidePlaceholder
    hideBorder
    hideDescription
    transformValue={returnOnlyValidNumbers}
    rules={{
      max: {
        value: REMAINING_TIME_MAX_MINUTES,
        message: t([translationRoot, "errors.remaining_time_threshold"], {
          max_minutes: REMAINING_TIME_MAX_MINUTES,
        }),
      },
      min: {
        value: REMAINING_TIME_MIN_MINUTES,
        message: t([translationRoot, "errors.remaining_time_threshold"], {
          max_minutes: REMAINING_TIME_MAX_MINUTES,
        }),
      },
    }}
    variant="extra-bottom-margin"
  >
    <Form.Input
      data-testid="countdown-remaining_time-input"
      type="number"
      min={REMAINING_TIME_MIN_MINUTES}
      max={REMAINING_TIME_MAX_MINUTES}
      suffix={
        <Typography.BodyMd>
          {t([translationRoot, "remaining_time_suffix"])}
        </Typography.BodyMd>
      }
      onWheelCapture={blockScroll}
    />
  </Form.Item>
);
